import chatMixin from "../../../mixins/chats";
import UserAvatar from '@/components/UserAvatar';

export default {
  name: "SuggestionList",
  mixins: [
    chatMixin
  ],
  props: {
    search: {
      type: String,
      default: ""
    },
    onClickSelectedParticipantChatMenu: {
      type: Function,
      default: () => {
      }
    }
  },
  computed: {
    xparticipants() {
      const query = (this.search || '').toLowerCase().trim();
      return this.participants
        .filter(x => {
          if (!x) return false;
          const userId = x.owner_id || x.id || x.user_id;
          if (userId === this.owner_id) return false;
          if (!query) return true;
          const fullName = `${x.first_name || ''} ${x.last_name || ''}`.toLowerCase();
          return fullName.indexOf(query) !== -1;
        })
        .map(x => ({
          ...x,
          icon_url: x.profile_picture || ''
        }));
    }
  },
  watch: {
    item: {
      handler() {
        //
      },
      deep: true
    },
    xparticipants() {
      // Keep activeIndex inside the list bounds whenever the filtered set changes.
      if (this.activeIndex >= this.xparticipants.length) {
        this.activeIndex = 0;
      }
    },
    search() {
      this.activeIndex = 0;
    }
  },
  data() {
    return {
      activeIndex: 0
    }
  },
  methods: {
    moveDown() {
      if (!this.xparticipants.length) return;
      this.activeIndex = (this.activeIndex + 1) % this.xparticipants.length;
    },
    moveUp() {
      if (!this.xparticipants.length) return;
      this.activeIndex = (this.activeIndex - 1 + this.xparticipants.length) % this.xparticipants.length;
    },
    selectActive() {
      if (!this.xparticipants.length) return false;
      const idx = Math.min(this.activeIndex, this.xparticipants.length - 1);
      this.onClickSelectedParticipantChatMenu(this.xparticipants[idx]);
      return true;
    }
  },
  components: {
    UserAvatar
  },
};
